module.exports = __webpack_public_path__ + "prod/1.42.2/img/plan_xinchuang2x.85ce5712.png";